interface variantStylesProps {
  [key: string]: {
    [key: string]: string;
  };
}

export const variantStyles: variantStylesProps = {
  card: {
    main: 'border-navy',
    mainDisabled: 'border-navy h-[215px]',
    default: 'border-transparent h-full'
  },
  shelfStatistic: {
    red: 'bg-[#D4605D] text-white',
    yellow: 'bg-[#F7B74D] text-fontBlock',
    green: 'bg-[#009965] text-white',
    default: 'bg-borderGray text-fontBlock'
  }
};

export const cardContainerStyles = (variant: string): string =>
  `relative border-t-4 bg-white shadow-cardShadow rounded w-full max-w-full box-border px-6 pt-[15px] pb-8 mb-8 min-h-[150px] ${
    (variant && variantStyles.card[variant]) || variantStyles.card.default
  }`;
export const cardTitleStyles = 'm-0 p-0 text-base font-nunitoMedium';
export const segmentContainerStyles = 'flex mt-2.5 w-full max-w-full';
export const segmentNotificationStyles =
  'font-nunitoRegular text-xs text-fontBlock absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2';
// const shelfStaticStyles = (variant: string) =>
//   `max-w-[116px] max-h-[48px] w-full font-nunitoMedium text-[11px] tracking-[0.6px] p-2.5 box-border mt-5 ml-6 flex items-center first:ml-0 ${(variant && variantStyles.shelfStatistic[variant]) || variantStyles.shelfStatistic.default
//   }`;
